<template>
  <div id="wangeditor">
    <div ref="editorElem" style="text-align:left;" />
  </div>
</template>
<script>
import { getImagePath } from '@/utils/util'
import E from 'wangeditor'
export default {
  name: 'RichTextEditor',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      editor: null,
      editorContent: ''
    }
  },
  computed: {
    accessToken() {
      const accessToken = this.$store.state.app.accessToken
      if (accessToken) {
        return `Bearer ${accessToken}`
      }
      return ''
    }
  }, // 接收父组件的方法
  watch: {
    value: function(value) {
      if (value !== this.editor.txt.html()) {
        this.editor.txt.html(this.value)
      }
    }
  },
  mounted() {
    this.editor = new E(this.$refs.editorElem)
    // 编辑器的事件，每次改变会获取其html内容
    this.editor.config.onchange = html => {
      this.editorContent = html
      this.$emit('change', this.editorContent)
      // this.callback(this.editorContent) // 把这个html通过catchData的方法传入父组件
    }
    this.editor.config.pasteTextHandle = function(content) {
      // content 即粘贴过来的内容（html 或 纯文本），可进行自定义处理然后返回
      if (content === '' && !content) return ''
      var str = content
      str = str.replace(/<xml>[\s\S]*?<\/xml>/ig, '')
      str = str.replace(/<style>[\s\S]*?<\/style>/ig, '')
      str = str.replace(/<\/?[^>]*>/g, '')
      str = str.replace(/[ | ]*\n/g, '\n')
      str = str.replace(/&nbsp;/ig, '')
      return str
    }
    this.editor.config.uploadImgServer = '/api/v1/file/upload-file'
    this.editor.config.uploadImgMaxSize = 2 * 1024 * 1024 // 2M
    this.editor.config.uploadImgHeaders = {
      'Authorization': this.accessToken
    }
    this.editor.config.uploadImgParams = { }
    this.editor.config.uploadFileName = 'file'
    // this.editor.customConfig.uploadImgAccept = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']
    this.editor.config.uploadImgAccept = ['png']
    this.editor.config.uploadImgParamsWithUrl = true
    this.editor.config.pasteFilterStyle = false
    this.editor.config.showFullScreen = false
    this.editor.config.uploadImgHooks = {
      customInsert: function(insertImgFn, result) {
        insertImgFn(getImagePath(result.data))
      }
    }
    this.editor.config.menus = [
      // 菜单配置
      'head', // 标题
      'bold', // 粗体
      'fontSize', // 字号
      'fontName', // 字体
      'italic', // 斜体
      'underline', // 下划线
      'strikeThrough', // 删除线
      'foreColor', // 文字颜色
      'backColor', // 背景颜色
      'link', // 插入链接
      'list', // 列表
      'justify', // 对齐方式
      'quote', // 引用
      'emoticon', // 表情
      'image', // 插入图片
      'table', // 表格
      'code', // 插入代码
      'undo', // 撤销
      'redo' // 重复
    ]
    this.editor.create() // 创建富文本实例
    this.editor.txt.html(this.value)
  }
}
</script>
